import { useMutation } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type UploadToSharepointVariables = {
  fileId: number;
  clientId: string;
  uploadUrl: string;
};

type UploadedSharepointItem = {
  id: string;
  name: string;
  webUrl: string;
  size: number | null;
};

export function useUploadToSharepointMutation() {
  return useMutation<{ data: UploadedSharepointItem }, Error, UploadToSharepointVariables>({
    mutationFn: ({ fileId, clientId, uploadUrl }) =>
      api.post<UploadedSharepointItem>(
        'sharepoint-docs/upload',
        { fileId, clientId, uploadUrl },
        // The backend reads the full file from S3 and streams it to Graph synchronously,
        // so large files can take several minutes. 5 minutes avoids a premature abort.
        { timeoutMs: 300_000 },
      ),
  });
}
